package pnemonic.balloon_pop.drawable

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

val Dog: ImageVector
    get() {
        if (_Dog != null) {
            return _Dog!!
        }
        _Dog = ImageVector.Builder(
            name = "Dog",
            defaultWidth = 163.46.dp,
            defaultHeight = 172.37.dp,
            viewportWidth = 163.46f,
            viewportHeight = 172.37f
        ).apply {
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(52.28f, 51.14f),
                    end = Offset(40.17f, 37.01f)
                )
            ) {
                moveTo(42.64f, 25.83f)
                curveTo(37.12f, 26.29f, 28.84f, 31.81f, 29.3f, 43.76f)
                curveTo(29.76f, 55.72f, 36.66f, 63.08f, 42.18f, 66.76f)
                curveTo(47.7f, 70.44f, 63.8f, 64.92f, 63.8f, 64.92f)
                lineTo(66.47f, 38.59f)
                curveTo(66.47f, 38.59f, 48.16f, 25.37f, 42.64f, 25.83f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(158.38f, 78.59f),
                    end = Offset(129.45f, 59.76f)
                )
            ) {
                moveTo(156.98f, 32.26f)
                curveTo(144.43f, 24.73f, 135.09f, 37.93f, 126.35f, 55.41f)
                curveTo(117.62f, 72.88f, 111.91f, 87.44f, 111.91f, 87.44f)
                lineTo(126.35f, 103.18f)
                curveTo(126.35f, 103.18f, 143.65f, 88.82f, 154.68f, 69.51f)
                curveTo(165.72f, 50.19f, 166.18f, 37.78f, 156.98f, 32.26f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(110.17f, 138.57f),
                    end = Offset(125.54f, 128.96f)
                )
            ) {
                moveTo(126.14f, 109.35f)
                lineTo(103.14f, 115.33f)
                curveTo(103.14f, 115.33f, 111.14f, 138.57f, 116.26f, 144.89f)
                curveTo(122.41f, 152.49f, 131.32f, 151.86f, 137.79f, 148.93f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(58.59f, 132.69f),
                    end = Offset(48.73f, 126.67f)
                )
            ) {
                moveTo(71.85f, 102.5f)
                curveTo(64.28f, 103.45f, 53.78f, 110.59f, 44.94f, 128.07f)
                curveTo(36.67f, 144.43f, 37.34f, 158f, 45.61f, 163.06f)
                curveTo(53.89f, 168.12f, 61.09f, 166.42f, 61.09f, 166.42f)
                lineTo(79.12f, 107.23f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(88.5f, 114.08f),
                    end = Offset(108.01f, 93.22f)
                )
            ) {
                moveTo(122.66f, 91.13f)
                curveTo(116.22f, 76.88f, 94.87f, 82.62f, 89.55f, 84.23f)
                curveTo(78.97f, 87.45f, 75.29f, 99.41f, 76.67f, 109.53f)
                curveTo(78.05f, 119.65f, 94.15f, 121.49f, 107.49f, 118.73f)
                curveTo(120.82f, 115.97f, 129.1f, 105.39f, 122.66f, 91.13f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(62.47f, 36.36f),
                    end = Offset(70.55f, 12.13f)
                )
            ) {
                moveTo(84.64f, 8.31f)
                curveTo(70.84f, -1.81f, 51.41f, -3.18f, 44.97f, 6.94f)
                curveTo(38.54f, 17.06f, 43.21f, 29.13f, 50.32f, 33.88f)
                curveTo(60.42f, 40.6f, 79.26f, 46.66f, 89.12f, 35.91f)
                curveTo(93.18f, 31.49f, 98.44f, 18.43f, 84.64f, 8.31f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(60.54f, 101.54f),
                    end = Offset(77.37f, 84.05f)
                )
            ) {
                moveTo(88.68f, 80.97f)
                curveTo(83.62f, 72.24f, 71.66f, 65.7f, 63.11f, 69.54f)
                curveTo(57.38f, 72.11f, 54.36f, 78.28f, 55.03f, 85.68f)
                curveTo(55.89f, 95.13f, 70.51f, 115.96f, 81.91f, 108.64f)
                curveTo(95.94f, 99.64f, 93.73f, 89.71f, 88.68f, 80.97f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(37.1f, 97.08f),
                    end = Offset(27.01f, 72.86f)
                )
            ) {
                moveTo(59.74f, 65.5f)
                curveTo(53.3f, 56.3f, 39.7f, 59.23f, 26.77f, 66.17f)
                curveTo(7.92f, 76.29f, -5.02f, 85.56f, 1.88f, 99.81f)
                curveTo(8.96f, 114.44f, 27.92f, 105.86f, 44.94f, 97.12f)
                curveTo(61.96f, 88.38f, 67.95f, 77.22f, 59.74f, 65.5f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(83.33f, 147.8f),
                    end = Offset(63.81f, 136.37f)
                )
            ) {
                moveTo(89.35f, 111.92f)
                curveTo(77.39f, 103.19f, 72.17f, 108.49f, 68.49f, 111.25f)
                curveTo(64.81f, 114.01f, 58.73f, 132.48f, 51.38f, 144.48f)
                curveTo(44.94f, 154.99f, 42.92f, 165.08f, 55.71f, 171.13f)
                curveTo(66.21f, 176.11f, 75.9f, 165.45f, 84.64f, 150.28f)
                curveTo(93.38f, 135.1f, 95.34f, 116.3f, 89.35f, 111.92f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(115.24f, 141.88f),
                    end = Offset(148.88f, 123.71f)
                )
            ) {
                moveTo(144.52f, 110.58f)
                curveTo(137.16f, 100.46f, 129.72f, 94.43f, 120.82f, 100.33f)
                curveTo(111.05f, 106.81f, 117.16f, 122.5f, 124.33f, 137.49f)
                curveTo(131.74f, 152.97f, 140.1f, 167.41f, 151.25f, 161.04f)
                curveTo(166.59f, 152.27f, 151.88f, 120.7f, 144.52f, 110.58f)
                close()
            }
            path(
                fill = Brush.linearGradient(
                    colorStops = arrayOf(
                        0f to Color(0xFFFF7200),
                        0.22f to Color(0xFFFF7700),
                        0.49f to Color(0xFFFF8500),
                        0.77f to Color(0xFFFF9D00),
                        1f to Color(0xFFFFB600)
                    ),
                    start = Offset(88.84f, 65.33f),
                    end = Offset(70.01f, 46.49f)
                )
            ) {
                moveTo(98.29f, 45.6f)
                curveTo(93.38f, 26.47f, 73.91f, 29.51f, 65.17f, 38.24f)
                curveTo(56.44f, 46.98f, 54.6f, 61.38f, 59.2f, 68.6f)
                curveTo(62.42f, 73.66f, 69.31f, 79.64f, 78.05f, 77.8f)
                curveTo(86.79f, 75.96f, 101.94f, 59.87f, 98.29f, 45.6f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(10.63f, 85.01f)
                curveTo(12.87f, 88.93f, 44.94f, 69.54f, 42.92f, 66.17f)
                curveTo(40.9f, 62.81f, 7.94f, 80.3f, 10.63f, 85.01f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(55.71f, 4.94f)
                curveTo(53.95f, 8.45f, 81.27f, 18.4f, 82.62f, 13.69f)
                curveTo(83.97f, 8.98f, 57.72f, 0.91f, 55.71f, 4.94f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(84.64f, 37.24f)
                curveTo(80.36f, 34.19f, 61.76f, 46.66f, 64.45f, 50.02f)
                curveTo(67.14f, 53.39f, 89.35f, 40.6f, 84.64f, 37.24f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(40.9f, 31.86f)
                curveTo(37.64f, 29.9f, 32.16f, 39.93f, 34.85f, 42.62f)
                curveTo(37.54f, 45.31f, 44.27f, 33.88f, 40.9f, 31.86f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(96.75f, 87.7f)
                curveTo(97.34f, 92.42f, 114.92f, 92.41f, 114.92f, 89.05f)
                curveTo(114.92f, 85.68f, 96.08f, 82.32f, 96.75f, 87.7f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(150.58f, 35.89f)
                curveTo(147.17f, 33.34f, 122.99f, 65.5f, 127.03f, 69.54f)
                curveTo(131.06f, 73.57f, 155.96f, 39.93f, 150.58f, 35.89f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(130.39f, 105.87f)
                curveTo(126.85f, 106.65f, 146.54f, 144.89f, 149.23f, 142.2f)
                curveTo(151.92f, 139.51f, 136.45f, 104.52f, 130.39f, 105.87f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(77.91f, 113.27f)
                curveTo(73.49f, 111.5f, 60.42f, 138.16f, 63.78f, 139.51f)
                curveTo(67.14f, 140.86f, 81.27f, 114.62f, 77.91f, 113.27f)
                close()
            }
            path(
                fill = SolidColor(Color.White),
                fillAlpha = 0.46f,
                strokeAlpha = 0.46f
            ) {
                moveTo(79.26f, 82.99f)
                curveTo(74.75f, 85.7f, 82.62f, 97.12f, 85.31f, 95.1f)
                curveTo(88f, 93.08f, 82.62f, 80.97f, 79.26f, 82.99f)
                close()
            }
        }.build()

        return _Dog!!
    }

@Suppress("ObjectPropertyName")
private var _Dog: ImageVector? = null
